module.exports = __webpack_public_path__ + "img/share-arrow.2fe63c5c.png";